<script>
	export let onClickSection;
	export let location;

	const getClass = (linkName, className ='', location) => {
		if (linkName === location) return `selected ${className}` ;
		return className;
	}	

	const HOME=	{ name: 'Nadia Berodia', link:'', className: 'home' };  
	const SECTIONS = [ // @TODO: To common place to put it in the "router"
		{name: 'Sobre mi', link:'about'},
		{name: 'Formación', link:'education'},
		{name: 'Terapia', link:'therapy'},
		{name: 'Contacto', link:'contact'},
	 ]
</script>

<div class='navigation-drawer'>
	<div class={getClass(HOME.link, HOME.className, location)} on:click={() => onClickSection(HOME.link)}><a href={HOME.link ? `#${HOME.link}`: '/'}>{HOME.name}</a></div>
	<div class={getClass(HOME.link, 'shorted-home', location)} on:click={() => onClickSection(HOME.link)}><a href={HOME.link ? `#${HOME.link}`: '/'}>NB</a></div>
	<ul>
		{#each SECTIONS as section}
		<li class={getClass(section.link, section.className, location)} on:click={() => onClickSection(section.link)}><a href={section.link ? `#${section.link}`: '/'}>{section.name}</a></li>
		{/each}
	</ul>
</div>

	

<style>

	.navigation-drawer {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: baseline;
		font-size: 18px;
	}

	.home {
		display: 'flex';
		justify-content: flex-start;
		margin-left: 20px;
	}

	ul {
		width: 30%;
		list-style: none;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	li {
		font-size: 18px;
		margin-right: 60px;
	}
	
	li.selected {
		text-decoration: underline;
	}

	.shorted-home {
		display: none;
	}

@media (max-width:1350px)  { 
		
		li {
			margin-right: 20px;
		}
		
		.home {
		margin-left: 10px;
		}

		.shorted-home {
			display: none;
			margin-right: auto;
		}

		.navigation-drawer{
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			padding: 0;
			width: 100%;
		}
}

@media (max-width:800px)  { 
		li {
			margin-right: 20px;
		}
		.home {
			margin-left: 0px;
			display: none;
		}
		.shorted-home {
			display: block;
			margin-right: auto;
		}

		.navigation-drawer{
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			padding: 0;
			width: 60%;
		}
}
</style>